/**
 * CookieBanner - Bandeau de consentement cookies RGPD
 * Conforme CDC Juridique v1.2 §9.6
 *
 * Exigences RGPD :
 * - Affichage premiere visite uniquement
 * - Boutons Accepter/Refuser de MEME accessibilite
 * - Pas de cookie wall (navigation non bloquee)
 * - Blocage cookies non essentiels avant consentement
 */

import { Link } from 'react-router-dom'
import { useCookieConsent } from '../../hooks/useCookieConsent'

export default function CookieBanner() {
  const { hasConsented, acceptAll, refuseAll } = useCookieConsent()

  // Ne pas afficher si consentement deja donne
  if (hasConsented) {
    return null
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 z-50 print:hidden"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
    >
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-4">
        {/* Texte explicatif */}
        <div className="flex-1 text-sm text-gray-600">
          <p id="cookie-banner-description">
            <span id="cookie-banner-title" className="sr-only">
              Gestion des cookies
            </span>
            RISK-DATA utilise des cookies pour ameliorer votre experience.
            Les cookies essentiels sont necessaires au fonctionnement du site.
            <Link
              to="/cookies"
              className="underline ml-1 text-blue-600 hover:text-blue-800"
            >
              En savoir plus
            </Link>
          </p>
        </div>

        {/* Boutons - MEME TAILLE ET VISIBILITE (exigence RGPD) */}
        <div className="flex gap-3 flex-shrink-0">
          {/* Bouton Refuser - meme style que Accepter */}
          <button
            type="button"
            onClick={refuseAll}
            className="px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Refuser
          </button>

          {/* Bouton Accepter */}
          <button
            type="button"
            onClick={acceptAll}
            className="px-6 py-2 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  )
}
